export const COMPANY = {
  name: "Gulf TechLab",
  tagline: "Innovation & Applied Technology",
  email: "info@gulftechlab.com",
  phone: "+971 50 695 2829",
  whatsapp: "971506952829", // international format, no +
  address: "Sharjah Free Zone, United Arab Emirates",
  hours: "Sunday – Thursday, 9:00 AM – 6:00 PM GST",
  logo: "https://customer-assets.emergentagent.com/job_ai-digital-growth/artifacts/0nanwv0u_1.png",
  social: {
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com",
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
  },
};

export const IMAGES = {
  heroBg: "https://static.prod-images.emergentagent.com/jobs/1d122a1a-9843-417e-9e46-31c5b8524b1c/images/9c49b93b39026b65bcbab04d91f20485b3257be512be6706890c0b617db7b482.png",
  neural: "https://static.prod-images.emergentagent.com/jobs/1d122a1a-9843-417e-9e46-31c5b8524b1c/images/55b27d09ab39a7b4db2ed6bf7e9c2d0904eb5bec2747c1f884b4997019d032e1.png",
  ecommerce: "https://static.prod-images.emergentagent.com/jobs/1d122a1a-9843-417e-9e46-31c5b8524b1c/images/ebc09fd7b62bef63dd582f73ea50c9dbfe516f4c67325ad9306d8705f14b9311.png",
  transform: "https://static.prod-images.emergentagent.com/jobs/1d122a1a-9843-417e-9e46-31c5b8524b1c/images/2098c0e3905ccc184f22aefaf68f3608510ecc6c921768fb9bd000cbc028b070.png",
  dubai: "/assets/generated/industries-hero.webp",
  skyline: "/assets/generated/industries-hero.webp",
  exec: "/assets/generated/service-consultancy-hero.webp",
  laptop: "/assets/generated/service-product-hero.webp",
};
